



































import { Component, Vue } from 'vue-property-decorator';
import { MetaInfo } from 'vue-meta/types/vue-meta';
import seoDefault from '@/utils/seo-default';

@Component({
  metaInfo(this: TermsAndPrivacy): MetaInfo {
    return {
      title: 'Terms And Privacy |',
      meta: [
        ...seoDefault({
          title: 'Terms And Privacy | Mysoalan',
          description:
            'Read about Mysoalan’s Privacy Policy regarding Personal Data and other information that is collected when you access and/or use our services.',
        }),
      ],
    };
  },
})
export default class TermsAndPrivacy extends Vue {
  privacy = [
    {
      title: 'Terms',
      content: [
        {
          type: 'p',
          text:
            'MySoalan is a website, mobile application, and related services company, owned by Msoalan Technology Sdn Bhd 202201004485 (1450182-W), that provides for the consumption and publication of written digital content. These General Terms of Use (the “Terms”) set out the terms and conditions by which MySoalan offers you access to use and enjoy mysoalan.com (the “Site”) and all services provided by MySoalan( the “Services”).',
        },
        {
          type: 'p',
          text:
            'The term “Account” refers to a basic MySoalan account maintained by an individual User or a single entity (“You”, “User”, or, collectively, “Users”).  The terms “Subscription,” “Subscription Membership,” and “Membership” apply to any paid subscription that allows Account holders to access premium and exclusive content (“Subscription Content”).',
        },
        {
          type: 'p',
          text:
            'The following General Terms of Use is a legal contract between You, either an individual User or a single entity, and MySoalan regarding Your use of the Site and Services. If you are accessing and using the Services on behalf of a company (such as your employer) or other legal entity, you represent and warrant that you have the authority to bind that entity to these Terms. In that case, “You” and “Your” will refer to the entity.',
        },
        {
          type: 'p',
          text:
            'PLEASE READ THE FOLLOWING TERMS OF USE CAREFULLY.  BY REGISTERING FOR, ACCESSING, BROWSING, POSTING, DOWNLOADING FROM, SUBSCRIBING TO, OR USING MYSOALAN, YOU ACKNOWLEDGE THAT YOU HAVE READ AND UNDERSTOOD, AND AGREE TO BE BOUND BY, THE FOLLOWING TERMS.  IF AT ANY TIME YOU DO NOT AGREE TO THESE TERMS, PLEASE IMMEDIATELY TERMINATE YOUR USE OF MYSOALAN.',
        },
      ],
    },
    {
      title: '1. Eligibility',
      content: [
        {
          type: 'p',
          text:
            'If You are using or opening an Account on behalf of a company, legal entity, or organization (collectively “Entity”), then You represent and warrant that You are an authorized representative of that Entity with the authority to bind such organization to these Terms; and agree to be bound by these Terms on behalf of the Entity.  BY USING MYSOALAN, YOU REPRESENT THAT You meet the eligibility requirements in this Section. In any case, You affirm that You are at least 13 years old, as MySoalan is not intended for children under 13.',
        },
      ],
    },
    {
      title: '2. Privacy; Additional Terms',
      content: [
        {
          type: 'p',
          text:
            'Your privacy is important to us. Our Privacy Policy is hereby incorporated into these Terms by reference.  Please read our Privacy Policy carefully for information on how we collect, use, and disclose Your personal information. You acknowledge and agree that your use of the Services is subject to our Privacy Policy.',
        },
        {
          type: 'p',
          text:
            'The Subscriber Agreement, is also hereby incorporated into these Terms by reference.',
        },
      ],
    },
    {
      title: '3. Individual Features and Services',
      content: [
        {
          type: 'p',
          text:
            'When using MySoalan, You will be subject to any additional posted guidelines, rules, and notices applicable to specific services and features which may be posted from time to time (the “Guidelines”).  All such Guidelines are hereby incorporated by reference into these Terms.',
        },
      ],
    },
    {
      title: '4. Subscription',
      content: [
        {
          type: 'p',
          text:
            'MySoalan offers access to premium and exclusive content by means of a Subscription.  A Subscription entitles You to access an unlimited number of questions and features during the subscription period.  Your access to the applicable content and related purchase transaction are subject to the Subscriber Agreement.',
        },
      ],
    },
    {
      title: 'Policy',
      content: [
        {
          type: 'p',
          text:
            'We are committed towards the protection of your personal information and privacy, This Policy serves to explain to you how we collect, process, manage and protect your personal data in accordance with the Personal Data Protection Act 2010. Such personal data may include, but is not limited to, information concerning your name, age, identity card number, passport number, address, email address, gender, date of birth, marital status, occupation, income range, medical information, contact information such as telephone, mobile and facsimile number, race, nationality, photographs and images, etc., obtained from you, third parties and public domain, which may be subject to applicable data protection and other similar laws.',
        },
        {
          type: 'p',
          text:
            'The list of personal data stated above is not exhaustive and may include other personal data depending on the nature of dealings or transaction.',
        },
      ],
    },
    {
      title: 'COLLECTION AND PROCESSING OF YOUR PERSONAL DATA',
      content: [
        {
          type: 'p',
          text:
            'Your personal data is usually captured via the Internet or otherwise, when you (i) fill up an application form or other relevant forms of ours; (ii) make purchases via our online platforms; (iii) participate in a competition, contest or other similar programmes organised by us; (iv) visit our office or websites; (v) respond to our marketing and promotional materials; or (vi) make an enquiry or provide feedback on our products and services. Your personal data is needed for but not limited to the following purposes:',
        },
        {
          type: 'ul',
          text: [
            'To provide you with the relevant products and services;',
            'For product marketing and after sales services;',
            'To send promotional and/or advertising materials to you;',
            'To conduct statistical analysis for product research and development;',
            'For administrative purposes, including billing, payment and debt collection; and',
            'To make relevant disclosures in compliance with all applicable laws and regulations.',
          ],
        },
        {
          type: 'p',
          text:
            'Should you fail to provide the information as requested, we may not be able to provide you with the relevant products or services as mentioned above.',
        },
      ],
    },
    {
      title: 'DISCLOSURE OF YOUR PERSONAL DATA',
      content: [
        {
          type: 'p',
          text:
            'Your personal data will be kept confidential but may be disclosed or transferred, whether in Malaysia or abroad, within MySoalan(“the Company”), or to our advisers, business associates and partners, government authorities and any third parties, as well as their respective contractors or agents for the purposes set out in above.',
        },
      ],
    },
    {
      title: 'SAFETY OF YOUR PERSONAL DATA',
      content: [
        {
          type: 'p',
          text:
            'We will ensure that your personal data kept by us is protected against any loss, misuse, modification, unauthorised or accidental access or disclosure, alteration or destruction.',
        },
      ],
    },
    {
      title: 'RIGHT OF ACCESS TO YOUR PERSONAL DATA',
      content: [
        {
          type: 'p',
          text:
            'You have the right to access, correct or change your personal data held by us by writing to us at the following address:',
        },
        {
          type: 'p',
          text: 'Email: hello@mysoalan.com',
        },
        {
          type: 'p',
          text: 'Upon the verification of your identity, you may:',
        },
        {
          type: 'ul',
          text: [
            'request for information pertaining to your personal data;',
            'request to make corrections or edit your personal data; or',
            'request to limit or to stop the processing of your personal data,',
            'subject to the requirements and restrictions under the relevant applicable laws, contractual conditions and a reasonable time period.',
          ],
        },
        {
          type: 'p',
          text:
            'By providing your personal data to us, you are consenting to the processing of your personal data by us in the manner as described above.',
        },
      ],
    },
    {
      title: 'AMENDMENTS TO THIS POLICY',
      content: [
        {
          type: 'p',
          text:
            'We reserve the right to amend and update this Policy from time to time, and the amended Policy will be uploaded onto our website, www.mysoalan.com.',
        },
      ],
    },
    {
      title: 'CONFLICT',
      content: [
        {
          type: 'p',
          text:
            'In the event of any conflict between this English language version of the Policy and its corresponding Bahasa Malaysia version, the terms in this English language version of the Policy shall prevail.',
        },
      ],
    },
  ];
}
